var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiagonalArrowSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C96E8",
    height: "20px",
    width: "20px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v512h512V0H0z M469.333,469.333c-8.341,8.341-21.824,8.341-30.165,0L85.333,115.499v225.835 c0,11.776-9.536,21.333-21.333,21.333s-21.333-9.557-21.333-21.333V64c0-2.773,0.576-5.547,1.643-8.149 c2.155-5.227,6.315-9.387,11.541-11.541c2.603-1.067,5.376-1.643,8.149-1.643h277.333c11.797,0,21.333,9.557,21.333,21.333 s-9.536,21.333-21.333,21.333H115.499l353.835,353.835C477.675,447.509,477.675,460.992,469.333,469.333z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrowSvgrepoCom);
export default __webpack_public_path__ + "static/media/diagonal-arrow-svgrepo-com.3b37a9cc51595a81661b468d85efa2a7.svg";
export { ForwardRef as ReactComponent };